import ApiClient from '../ApiClient';
import {
  AuthorizeTransactionRequest,
  DigitalWalletShippingMethod,
  DigitalWalletsShippingMethods,
  DigitalWalletSuborderShippings,
} from './types';

class DigitalWalletsBase {
  constructor(protected apiClient: ApiClient) {}

  public async proceedDigitalWalletPayPayment(paymentRequest: AuthorizeTransactionRequest): Promise<void> {
    await this.apiClient.post('/shoppingCart/paymentMethod/digital-wallet/authorize', {
      body: paymentRequest,
    });
  }

  protected async getDigitalWalletsShippingMethods(
    country: string,
    state: string,
    city: string,
    zipcode: string,
  ): Promise<DigitalWalletsShippingMethods> {
    const queryParams = new URLSearchParams({
      country,
      state,
      city,
      zipcode,
    });

    const res = await this.apiClient.get(
      `/shoppingCart/paymentMethod/digital-wallet/shipping-options?${queryParams.toString()}`,
    );

    return res.json();
  }

  protected findCheapestOptions(shipments: DigitalWalletSuborderShippings[]): DigitalWalletShippingMethod[] {
    return shipments.map((shipment: DigitalWalletSuborderShippings) => shipment.shippingOptions[0]);
  }

  protected findExpensiveOptions(shipments: DigitalWalletSuborderShippings[]): DigitalWalletShippingMethod[] {
    return shipments.map(
      (shipment: DigitalWalletSuborderShippings) => shipment.shippingOptions[shipment.shippingOptions.length - 1],
    );
  }

  protected calculateTotal(options: DigitalWalletShippingMethod[]): number {
    return options.reduce((sum: number, opt: DigitalWalletShippingMethod) => sum + opt.amount, 0);
  }

  protected createIdentifier(
    options: DigitalWalletShippingMethod[],
    shipments: DigitalWalletSuborderShippings[],
  ): string {
    return options
      .map((opt: DigitalWalletShippingMethod, index: number) => `${shipments[index].subOrderId}-${opt.methodId}`)
      .join('_');
  }

  protected getLatestDeliveryDate(options: DigitalWalletShippingMethod[]): string {
    const dates = options
      .map((opt) => opt.deliveryDate)
      .filter((date): date is string => date !== null)
      .sort((a, b) => {
        const [monthA, dayA, yearA] = a.split('-').map(Number);
        const [monthB, dayB, yearB] = b.split('-').map(Number);
        return new Date(yearB, monthB - 1, dayB).getTime() - new Date(yearA, monthA - 1, dayA).getTime();
      });
    return dates.length > 0 ? dates[0] : '';
  }
}

export default DigitalWalletsBase;
